import "./base.js";
import "./mixins/conditional_visibility.js";

// block element positioned staticly that looks like a squarish speech bubble and points to a link that opened it. The
// anchor will simply align itself horizontally so it points to the center of the trigger element. Any content can be
// placed inside the callout. The callout cannot be dismissed once opened.

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

AppointmentBooking.Wizard.Views.Callout = class Callout extends (
  AppointmentBooking.Wizard.Views.Mixins.ConditionalVisibilty(AppointmentBooking.Wizard.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize(options = {}) {
    super.initialize(options);

    if (options.anchor) {
      this.anchor = jQuery(`<div class='anchor ${options.anchor}'>`);
    }

    if (this.model != null) {
      return this.listenTo(this.model, "change", () => {
        if (this.visible) {
          return this.render();
        }
      }); // Only update on change if the callout visibility condition is met
    }
  }

  // RENDERING

  render() {
    super.render(...arguments);
    this.$el.prepend(this.anchor);

    return this;
  }
};
AppointmentBooking.Wizard.Views.Callout.prototype.tagName = "div";
AppointmentBooking.Wizard.Views.Callout.prototype.className = "appointment-booking-wizard-callout";
AppointmentBooking.Wizard.Views.Callout.prototype.template = false;
